import React from "react";
import StepActions from "./StepActions";

const Step = ({ step }) => {
    return (
        <div className='d-flex justify-content-between'>
            {step.name}
            <StepActions step={step} />
        </div>
    );
};

export default Step;